/**
 * @deprecated Import from `@fluentui/react` package instead.
 */
export { Separator, SeparatorBase } from '@fluentui/react/lib/Separator';
export type {
  ISeparator,
  ISeparatorProps,
  ISeparatorStyleProps,
  ISeparatorStyles,
} from '@fluentui/react/lib/Separator';
